"use strict";

var _toConsumableArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/toConsumableArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.float32Array = void 0;

var float_1 = require("./float");

var array_1 = require("./array");

var Converters_1 = require("../check/arbitrary/definition/Converters");

function toTypedMapper(data) {
  return Float32Array.from(data);
}

function fromTypedUnmapper(value) {
  if (!(value instanceof Float32Array)) throw new Error('Unexpected type');
  return _toConsumableArray(value);
}

function float32Array() {
  var constraints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, Converters_1.convertFromNext)((0, Converters_1.convertToNext)((0, array_1.array)((0, float_1.float)(Object.assign(Object.assign({}, constraints), {
    next: true
  })), constraints)).map(toTypedMapper, fromTypedUnmapper));
}

exports.float32Array = float32Array;